import { create } from 'zustand';
import { supabase } from "./supabase";

const useAppStore = create((set) => ({
  user: null,
  profile_image: null,
  loading: false,
  breadcrumb: localStorage.getItem("breadcrumb") || "Dashboard",

  uploadProfilePicture: async (file, userId) => {
    set({ loading: true });
    try {
      const fileExt = file.name.split(".").pop();
      const fileName = `${userId}-${Date.now()}.${fileExt}`;
      const filePath = `avatars/${fileName}`;

      // 1️⃣ Upload to Supabase Storage
      const { error: uploadError } = await supabase.storage
        .from("profiles_images")
        .upload(filePath, file, { upsert: true });

      if (uploadError) throw uploadError;

      // 2️⃣ Get public URL
      const { data } = supabase.storage.from("profiles_images").getPublicUrl(filePath);
      const publicUrl = data.publicUrl;

      // 3️⃣ Update user record in DB
      const { error: dbError } = await supabase
        .from("employees")
        .update({ image: publicUrl })
        .eq("id", userId);

      if (dbError) throw dbError;

      set({ profile_image: publicUrl, loading: false });
      return publicUrl;
    } catch (err) {
      console.error("Upload error:", err);
      set({ loading: false });
    }
  },

  setBreadcrumb: (breadcrumb) => {
    localStorage.setItem("breadcrumb", breadcrumb);
    set({ breadcrumb });
  },

  setUser: (user) => set({ user }),
  resetUser: () => set({ user: null }),
}));

export default useAppStore;